
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Carousel from './Carousel';

class BannerCarousel extends PureComponent {

    static propTypes = {
        bannerCarouselData: PropTypes.array,
    }

    constructor(props) {
        super(props);
        this.settings = {
            dots: true,
            slidesToShow: 1,
            arrows: false,
            pauseOnHover: true,
            adaptiveHeight: true
        };
    }

    render() {
        const { bannerCarouselData, className, style, verticalPosition} = this.props;
        const processedData = [];
        let htmlString;
        if (!bannerCarouselData) {
            return (
                <div style={{ height: '200px', background: 'url(https://static.lenskart.com/media/mobile/images/img-loader.gif) center no-repeat' }}></div>
            );
        }
        if (bannerCarouselData) {
            bannerCarouselData.forEach((item, index) => {
                if (item.html) {
                    const css = item.css ? item.css : '';
                    htmlString = item.html + css;
                    processedData.push(<div key={`carousel-html-banner${index}`} dangerouslySetInnerHTML={{ __html: htmlString }}></div>);
                } else {
                    processedData.push(<div key={`carousel-html-banner${index}`} style={{ float: 'left', textAlign: 'left' }}>
                        <a
                            href={item.url}
                            onClick={() => {
                            window.dtm.LenskartRewamp.collection.click.bannerclickdtm(item.pageName, item.componentName, index + 1, null, verticalPosition);
                            }}
                            target="_parent"
                        >
                            <img src={item.src} alt={item.title} title={item.title} />
                        </a>
                    </div>);
                }
            });
        }

        return (
            <section className={className} style={style}>
                {processedData && <Carousel carouselHtmlData={processedData} carouselConfig={this.settings}></Carousel>}
            </section>
        );
    }

}

export default BannerCarousel;


